import React from 'react';
import {useFrontContext} from "v4/contexts/FrontContext";
import {CONTACT, PROSPECT, QUOTE, TASK} from "v4/data/entities";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import ContactsPage from "v4/pages/front/Contacts/ContactsPage";
import ProspectPage from "v4/pages/front/Prospect/ProspectPage";
import ProspectsPage from "v4/pages/front/Prospects/ProspectsPage";
import QuotesPage from "v4/pages/front/Quotes/QuotesPage";
import TasksPage from "v4/pages/front/Tasks/TasksPage";

export default function ListingPageLayout() {
    const {currentListingEntity, tab} = useFrontContext();
    const {currentRoute} = useNavigation();
    const isProspectPage = currentRoute?.isDetail;

    return (
        <>
            {switchListingPage(currentListingEntity, tab, isProspectPage)}

            {isProspectPage && <ProspectPage/>}
        </>
    )
}

function switchListingPage(entity, tab, isProspectPage) {
    switch (entity) {
        case CONTACT:
            return <ContactsPage key={tab?.id} tab={tab} isProspectPage={isProspectPage}/>;
        case PROSPECT:
            return <ProspectsPage key={tab?.id} tab={tab} isProspectPage={isProspectPage}/>;
        case TASK:
            return <TasksPage key={tab?.id} tab={tab} isProspectPage={isProspectPage}/>;
        case QUOTE:
            return <QuotesPage key={tab?.id} tab={tab} isProspectPage={isProspectPage}/>;
        default:
            return null;
    }
}
